var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501296876,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5797,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 611.328h896v99.84H64z",
    fill: "#FFFFFF",
    opacity: 0.75,
    "p-id": 5798
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 711.168h896v99.392H64v-99.392z m0-497.728h896v99.2H64v-99.2z",
    fill: "#ED1B24",
    opacity: 0.75,
    "p-id": 5799
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.44h896v16H64v-16z m0 581.12h896v16H64v-16z",
    fill: "#ED1B24",
    "p-id": 5800
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 412.544h896v198.784H64z",
    fill: "#241D4F",
    opacity: 0.75,
    "p-id": 5801
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 312.704h896v99.84H64z",
    fill: "#FFFFFF",
    opacity: 0.75,
    "p-id": 5802
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M944 611.328H960v99.84h-16z",
    fill: "#EEEEEE",
    "p-id": 5803
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M944 711.168h64v99.392h-64v-99.392z m0-497.728h64v99.2h-64v-99.2z",
    fill: "#ED1B24",
    "p-id": 5804
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M944 412.544H960v198.784h-16z",
    fill: "#241D4F",
    "p-id": 5805
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M944 312.704H960v99.84h-16v-99.84zM64 611.328h16v99.84H64v-99.84z",
    fill: "#EEEEEE",
    "p-id": 5806
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64 711.168h64v99.392H64v-99.392z m0-497.728h64v99.2H64v-99.2z",
    fill: "#ED1B24",
    "p-id": 5807
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64 412.544h16v198.784H64z",
    fill: "#241D4F",
    "p-id": 5808
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64 312.704h16v99.84H64z",
    fill: "#EEEEEE",
    "p-id": 5809
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/th.d4bdfde0.svg";
export { ForwardRef as ReactComponent };